export enum SideNavActionTypes {
    TOGGLE_SIDENAV = "TOGGLE_SIDENAV"
}

export type SideNavAction = 
    | ReturnType<typeof toggleSideNav>;

export function toggleSideNav() {
    return {
        type: SideNavActionTypes.TOGGLE_SIDENAV
    } as const;
}